import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { INationality } from 'src/app/interfaces/country';
import { DataService } from 'src/app/services/data.service';
import { pageKey } from 'src/app/services/mapping.service';
import { statusObj } from 'src/app/dummy/status';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-nationality',
  templateUrl: './add-nationality.component.html',
  styleUrls: ['./add-nationality.component.scss']
})
export class AddNationalityComponent implements OnInit {
  @ViewChild("focus",{static:false}) inputRef:ElementRef;

  form: FormGroup;
  code: AbstractControl;
  description: AbstractControl;


  constructor(
    public dialogRef: MatDialogRef<AddNationalityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      code: [null, Validators.required],
      description: [null],
    });
    this.code = this.form.controls['code'];
    this.description = this.form.controls['description'];
  }

  create(f: any, isNew: boolean) {
    if(this.form.valid){
      this.form.disable()
      const { code, description } = f;
      const item: INationality = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.collection('users').doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: code,
        description: description,
        status: statusObj.active,
      }
      this.store.save(this.ds.nationalityRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Nationality has been created.', 'Done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }
    
  }

}
